import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { OverviewNewComponent } from './overview-new.component';

const routes: Routes = [{ path: '', component: OverviewNewComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OverviewNewRoutingModule { }
